// import Status from '@/views/status/status-info.js'
const Status = () =>
  import(/* webpackChunkName: "status" */ '@/views/status/status-info.js')
import { getFirstInfo } from '@/api/distributor-api'

export default function (router) {
  // 状态页
  router.push({
    path: '/partner/status/:status',
    name: 'status',
    component: Status,
    beforeEnter: async (to, form, next) => {
      if (
        to.params.status === 'second-distributor-no-permission' ||
        to.params.status === 'first-distributor-no-permission'
      ) {
        try {
          let {
            result: { distributorResult },
          } = await getFirstInfo()
          if (!distributorResult || distributorResult.status !== 1) {
            if (to.params.status === 'first-distributor-no-permission') {
              return next()
            } else {
              return next({
                name: 'status',
                params: { status: 'first-distributor-no-permission' },
                query: { hideSideMenu: 1 },
              })
            }
          } else if (
            distributorResult.distributorLevel !== 0 ||
            distributorResult.level < 2
          ) {
            if (to.params.status === 'second-distributor-no-permission') {
              return next()
            } else {
              return next({
                name: 'status',
                params: { status: 'second-distributor-no-permission' },
              })
            }
          } else {
            return next({ name: 'MySalesPerformance' })
          }
        } catch (e) {
          console.log(e)
        }
      } else {
        return next()
      }
    },
  })
}
